import { FetchError, ofetch } from 'ofetch';
import { clientEnv } from './env';

export const apiClient = ofetch.create({
  baseURL: clientEnv.VITE_API_URL,
  onResponse({ response, error }) {
    if (typeof response._data === 'object' && 'status' in response._data) {
      const { data, status, error: errorMsg } = response._data;
      if (errorMsg || status !== 'success') {
        if (typeof errorMsg === 'string') {
          throw new FetchError(errorMsg, { cause: error });
        } else if (typeof errorMsg === 'object' && 'message' in errorMsg) {
          throw new FetchError(errorMsg.message, { cause: errorMsg });
        }
      }
      response._data = data;
    }
  },
});
